import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, Typography, } from '@mui/material';
import { Cancel, SkipNext } from '@mui/icons-material';
import {useDispatch,} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { obtenerRegistrosPersonalizado } from 'store/actions/customAction';
import Formulario from 'components/formulario';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { useStyles } from './estilos';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import CalendarioElaboracionPlanDeMedios from './CalendarioPlanDeMedios';

let datosDeEmpresas = [];
const FormularioSeleccionarMedio = ({title, openFullScreenDialog, handleClose, datosDelMedio}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const [registrosDePlanDeMedios] = useState("registrosDePlanDeMedios");
    const {nivelCobertura, nombreMedio, tipoCandidatura, idTipoMedioDeComunicacion} = datosDelMedio;
    const [abrirPlanDeMedio, setAbrirPlanDeMedio] = useState(false);

    useEffect(() => {
      obtenerRegistrosDePlanDeMedios()
    }, [])

    const obtenerRegistrosDePlanDeMedios = async () => {
      const copiaDeCampos = Object.assign({}, camposDelFormulario);

      setcargandoSolicitud(true);
      let respuesta = await dispatch(obtenerRegistrosPersonalizado({
          controller: registrosDePlanDeMedios,
          saveInStore: false,
          nombreDelMetodo: `listar/medios/${idTipoMedioDeComunicacion}/${nivelCobertura?.id || ""}` ,
      }));

      setcargandoSolicitud(false);

      if(respuesta?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

      if(respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: "No se encontraron medios de comunicación para este tipo de cobertura", mostrarRespuesta: true, });

      datosDeEmpresas = respuesta.data;
      copiaDeCampos.corporacion.list = respuesta?.data?.map( ({id, nombreConcatenado}) => ({id, name: nombreConcatenado}) )
      // copiaDeCampos.corporacion.list = respuesta?.data?.map( ({id, nombre}) => ({id, name: nombre}) )
      setCamposDelFormulario(copiaDeCampos);
    }

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
      corporacion: {
        idelement: "corporacion", value: null , label: "Seleccione el medio de comunicación *", pattern:"^[1-9][0-9]*$", validators: ['required'],
        errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '100%'
      },
    });

    const cancelarAccion = () => { handleClose(true) };

    const siguiente = async (dataForm) => {
      // console.log("dataForm", )
        datosDelMedio.idMedioDeComunicacion = dataForm.corporacion?.id || "";
        datosDelMedio.nombreMedioDeComunicacion = dataForm.corporacion?.name || "";
        datosDelMedio.empresa = datosDeEmpresas?.find( ({id}) => dataForm.corporacion?.id === id )
        setAbrirPlanDeMedio(true);
    }

    const [listadoDeBotones]= React.useState({
        "guardarDatos":{"label":"Continuar", "icon": <SkipNext />, "callback":siguiente,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":cancelarAccion,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: "", mostrarRespuesta: false, });
    };
    const cerrarPlanDeMedios= () => { setAbrirPlanDeMedio(false) };

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
      <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={handleClose}
        title={title}
        fullscreen={false}
        maxWidth={"md"}
      >
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
            <Card>
                <Typography className={classes.tituloFormulario}> {tipoCandidatura || ""} - {nombreMedio || ""} - ({nivelCobertura?.name || ""}) </Typography>
                <CardContent>
                    <Formulario
                        elements={camposDelFormulario}
                        buttonList={listadoDeBotones}
                    />
                </CardContent>
            </Card>
            {abrirPlanDeMedio && (
                <CalendarioElaboracionPlanDeMedios
                    openFullScreenDialog={abrirPlanDeMedio}
                    handleClose={cerrarPlanDeMedios}
                    title={"Formulario para asignar cobertura"}
                    datosDelMedio={datosDelMedio}
                />
            )}
        </Fragment>
      </DialogoPantallaCompleta>
    );
}

export default FormularioSeleccionarMedio;